import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const CONTACTS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('CONTACTS');
export const CONTACTS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	CONTACTS_CRUD_ACTION_CONSTANTS
);
